module.exports = __webpack_public_path__ + "img/Rectangle 2@2x.23977e8b.png";